module.exports = __webpack_public_path__ + "static/media/activity.8026378e.png";